// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.chat-reply-message[data-v-1a5da214] {
  display: flex;
  margin: 3px 0px 7px 0px !important;
  width: 100%;
  cursor: pointer;
  max-height: 57px;
}
.chat-reply-message .quote[data-v-1a5da214] {
  font-size: 0.5em;
}
.chat-reply-message .color-line[data-v-1a5da214] {
  width: 3px;
  flex-basis: 3px;
  flex-shrink: 0;
  border-radius: 3px;
  margin-right: 10px;
  margin-left: 5px;
}
.chat-reply-message .reply-block[data-v-1a5da214] {
  display: flex;
  word-wrap: anywhere;
  overflow: hidden;
}
.chat-reply-message .reply-block .reply-img[data-v-1a5da214] {
  margin-right: 10px;
  display: flex;
}
.chat-reply-message .reply-block .reply-img img[data-v-1a5da214] {
  margin: auto;
  height: 35px;
  min-width: 5px;
  border-radius: 2px;
  max-width: 70px;
}
.chat-reply-message .reply-block .reply-info[data-v-1a5da214] {
  overflow: hidden;
  margin-right: -1px;
}
.chat-reply-message .reply-block .reply-info .reply-info-name[data-v-1a5da214] {
  font-size: 12px;
  font-weight: bold;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.chat-reply-message .reply-block .reply-info .reply-info-text[data-v-1a5da214] {
  color: var(--message-reply-color);
  max-height: 3em;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 756px;
  white-space: nowrap;
  padding-right: 3px;
  display: -webkit-box;
  line-clamp: 2;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
.chat-reply-message .reply-block .reply-info .reply-info-text .reply-quote[data-v-1a5da214] {
  text-indent: 0;
  background-color: var(--message-reply-bgcolor);
  white-space: pre-wrap;
}
.chat-reply-message.deleted-message .reply-info-text[data-v-1a5da214] {
  margin-top: 4px;
  margin-bottom: 4px;
  margin-right: 4px;
}
.chat-reply-message.short[data-v-1a5da214] {
  max-width: 250px;
}
`, "",{"version":3,"sources":["webpack://./js/app/components/chat/ChatReplyMessage.vue"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,kCAAkC;EAClC,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,UAAU;EACV,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,aAAa;AACf;AACA;EACE,YAAY;EACZ,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;AAClB;AACA;EACE,iCAAiC;EACjC,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,oBAAoB;EACpB,aAAa;EACb,qBAAqB;EACrB,4BAA4B;AAC9B;AACA;EACE,cAAc;EACd,8CAA8C;EAC9C,qBAAqB;AACvB;AACA;EACE,eAAe;EACf,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,gBAAgB;AAClB","sourcesContent":[".chat-reply-message[data-v-1a5da214] {\n  display: flex;\n  margin: 3px 0px 7px 0px !important;\n  width: 100%;\n  cursor: pointer;\n  max-height: 57px;\n}\n.chat-reply-message .quote[data-v-1a5da214] {\n  font-size: 0.5em;\n}\n.chat-reply-message .color-line[data-v-1a5da214] {\n  width: 3px;\n  flex-basis: 3px;\n  flex-shrink: 0;\n  border-radius: 3px;\n  margin-right: 10px;\n  margin-left: 5px;\n}\n.chat-reply-message .reply-block[data-v-1a5da214] {\n  display: flex;\n  word-wrap: anywhere;\n  overflow: hidden;\n}\n.chat-reply-message .reply-block .reply-img[data-v-1a5da214] {\n  margin-right: 10px;\n  display: flex;\n}\n.chat-reply-message .reply-block .reply-img img[data-v-1a5da214] {\n  margin: auto;\n  height: 35px;\n  min-width: 5px;\n  border-radius: 2px;\n  max-width: 70px;\n}\n.chat-reply-message .reply-block .reply-info[data-v-1a5da214] {\n  overflow: hidden;\n  margin-right: -1px;\n}\n.chat-reply-message .reply-block .reply-info .reply-info-name[data-v-1a5da214] {\n  font-size: 12px;\n  font-weight: bold;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  overflow: hidden;\n}\n.chat-reply-message .reply-block .reply-info .reply-info-text[data-v-1a5da214] {\n  color: var(--message-reply-color);\n  max-height: 3em;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  max-width: 756px;\n  white-space: nowrap;\n  padding-right: 3px;\n  display: -webkit-box;\n  line-clamp: 2;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n}\n.chat-reply-message .reply-block .reply-info .reply-info-text .reply-quote[data-v-1a5da214] {\n  text-indent: 0;\n  background-color: var(--message-reply-bgcolor);\n  white-space: pre-wrap;\n}\n.chat-reply-message.deleted-message .reply-info-text[data-v-1a5da214] {\n  margin-top: 4px;\n  margin-bottom: 4px;\n  margin-right: 4px;\n}\n.chat-reply-message.short[data-v-1a5da214] {\n  max-width: 250px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
